// /* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import styles from "./style.module.css";
// import UnifiedPaymentsLogo from "../assets/Home/unifiedPaymentsLogo.webp";
import RemitaLogo from "../assets/Home/remitaLogo.png";
import FlutterwaveLogo from "../assets/Home/flutterwaveLogo.webp";
// import InterswitchLogo from "../assets/Home/interswitchLogo.png";
import EtransacLogo from "../assets/Home/etransacLogo.png";
import Logo from "../assets/Home/esirsLogo.png";
import { ReactComponent as CloseMobileMenu } from "../assets/Home/closeMobileMenu.svg";
import { ReactComponent as MobileMenu } from "../assets/Home/hamburger.svg";
import { ReactComponent as BannerLogo } from "../assets/Home/bannerLogo.svg";

// Socials
import { ReactComponent as Norlics } from "../assets/Home/Norlics.svg";
import { ReactComponent as Instagram } from "../assets/Home/instagram.svg";
import { ReactComponent as Facebook } from "../assets/Home/facebook.svg";
import { ReactComponent as X } from "../assets/Home/x.svg";
import { ReactComponent as ArrowRight } from "../assets/Home/arrow-right.svg";
import HomeSlider from "./carousel";
import Footer from "./footer";
import TaxCalcInputter from "./sidebars/taxCalcInputter";
import LookUpESBN from "./sidebars/lookup/esbn";
import LookUpReceipt from "./sidebars/lookup/receipt";
import LookUpCertificate from "./sidebars/lookup/certificate";
import { useHistory } from "react-router";
import NewsModal from "./news.modal";

// const coySocialId = process.env.REACT_APP_COYSOCIALID;
const coyIMS = process.env.REACT_APP_COYADMIN;

const Home = () => {
	const [mobileState, setMobileState] = useState({
		state: false,
		link: ""
	});
	const [newsModalShowing, setNewsModalShowing] = useState(true);

	// mobileActive
	const [lookupDropdown, setLookupDropdown] = useState(false);

	const history = useHistory();

	return (
		<>
			<TaxCalcInputter />
			<LookUpESBN />
			<LookUpReceipt />
			<LookUpCertificate />
			<div>
				<header className={styles.header}>
					<div className={styles.desktop__header_logo}>
						{/* <img src="/anscims_logo.svg" alt="Logo" /> */}
						<img src={Logo} alt="Logo" />
					</div>
					<img
						src={Logo}
						alt="NorIMS mobile logo"
						className={styles.mobile__header_logo}
					/>

					<nav className={styles?.desktop__nav}>
						{/* <NavLink to="/login" className={styles.nav__link}>
              Get ESBN
            </NavLink> */}
						<NavLink
							to={{
								pathname: "/login",
								state: { anscims: true }
							}}
							className={styles.nav__link}
						>
							Login to {coyIMS}
						</NavLink>
						<li className="dropdown list-unstyled">
							<NavLink
								to="#"
								className={`${styles.nav__link} dropdown-toggle`}
								data-toggle="dropdown"
							>
								Retrieve ESBN <span className="caret"></span>
							</NavLink>
							<ul
								className="dropdown-menu"
								aria-labelledby="about-us"
							>
								<li
									type="button"
									data-toggle="modal"
									data-target="#lookUpESBN"
								>
									<NavLink to="">
										<span>Find ESBN</span>
									</NavLink>
								</li>
								{/* <li
                  type="button"
                  data-toggle="modal"
                  data-target="#lookUpReceipt"
                >
                  <NavLink to="">
                    <span>Lookup Receipt</span>
                  </NavLink>
                </li>
                <li
                  type="button"
                  data-toggle="modal"
                  data-target="#lookUpCertificate"
                >
                  <NavLink to="">
                    <span>Lookup Certificate</span>
                  </NavLink>
                </li> */}
							</ul>
						</li>
						<p
							type="button"
							className={`${styles.nav__link}`}
							data-toggle="modal"
							data-target="#myModal2"
						>
							Tax Calculator
						</p>
						<NavLink
							to={{
								pathname: "#",
								state: { anscims: true }
							}}
							className={styles.nav__link}
						>
							News
						</NavLink>
						<div className="dropdown">
							<button
								className={`btn btn-default ${styles.nav__payment_btn} dropdown-toggle`}
								type="button"
								id="about-us"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>
								Pay Tax with
								<span
									className="caret"
									style={{ marginLeft: "8px" }}
								></span>
							</button>
							<ul
								className="dropdown-menu"
								aria-labelledby="about-us"
							>
								{/* <li>
									<NavLink to="/unifiedpaymentpage">
										<span style={{ marginRight: "5px" }}>
											<img
												src={UnifiedPaymentsLogo}
												alt="Unified Payments"
												style={{ height: "23px" }}
											/>
										</span>
										<span>Unified Payment</span>
									</NavLink>
								</li> */}
								<li>
									<NavLink to="/flutterwavepage">
										<span style={{ marginRight: "5px" }}>
											<img
												src={FlutterwaveLogo}
												alt="Flutterwave"
												style={{ height: "23px" }}
											/>
										</span>
										<span>Flutterwave</span>
									</NavLink>
								</li>
								<li>
									<NavLink to="/remitapage">
										<span style={{ marginRight: "5px" }}>
											<img
												src={RemitaLogo}
												alt="Remita Payments"
												style={{ height: "22px" }}
											/>
										</span>
										<span>Remita pay</span>
									</NavLink>
								</li>
								{/* <li>
									<NavLink to="/interswitchpage">
										<span style={{ marginRight: "5px" }}>
											<img
												src={InterswitchLogo}
												alt="Interswitch"
												style={{ height: "23px" }}
											/>
										</span>
										<span>Interswitch</span>
									</NavLink>
								</li> */}
								<li>
									<NavLink to="/etransacpage">
										<span style={{ marginRight: "5px" }}>
											<img
												src={EtransacLogo}
												alt="E-transac"
												style={{ height: "23px" }}
											/>
										</span>
										<span>E-transac</span>
									</NavLink>
								</li>
							</ul>
						</div>
					</nav>
					{mobileState?.state ? (
						<CloseMobileMenu
							className={styles?.mobile__icon}
							onClick={() =>
								setMobileState({ ...mobileState, state: false })
							}
						/>
					) : (
						<MobileMenu
							className={styles?.mobile__icon}
							onClick={() =>
								setMobileState({ ...mobileState, state: true })
							}
						/>
					)}
					{mobileState.state && (
						<div className={styles?.mobile__nav}>
							<ul>
								{/* <li
                    className={`${mobileState.link === `Get ESBN` && styles.mobileActive}`}
                    onClick={(e) => setMobileState({ ...mobileState, link: e.target.innerText })}>
                    Get ESBN
                  </li> */}
								<li
									className={`${
										mobileState.link ===
											`Login to Enugu CMS` &&
										styles.mobileActive
									}`}
									onClick={(e) =>
										setMobileState({
											...mobileState,
											link: e.target.innerText
										})
									}
								>
									Login to Enugu CMS
								</li>
								<li className={styles?.lookup}>
									<span
										className={`${
											mobileState.link === `Lookup ` &&
											styles.mobileActive
										}`}
										onClick={(e) => {
											setMobileState({
												...mobileState,
												link: e.target.innerText
											});
											setLookupDropdown(!lookupDropdown);
										}}
									>
										Search <span className="caret"></span>
									</span>
									{lookupDropdown && (
										<ul>
											<li>Retrieve ESBN</li>
											{/* <li>Retrieve Receipt</li>
											<li>Retrieve Certificate</li> */}
										</ul>
									)}
								</li>
								<li
									className={`${
										mobileState.link === `Tax Calculator` &&
										styles.mobileActive
									}`}
									onClick={(e) =>
										setMobileState({
											...mobileState,
											link: e.target.innerText
										})
									}
								>
									Tax Calculator
								</li>
								<li
									className={`${
										mobileState.link === `News` &&
										styles.mobileActive
									}`}
									onClick={(e) =>
										setMobileState({
											...mobileState,
											link: e.target.innerText
										})
									}
								>
									News
								</li>
							</ul>

							<div className={`dropdown ${styles.payments}`}>
								<button
									className={`btn btn-default ${styles.nav__payment_btn} dropdown-toggle`}
									type="button"
									id="about-us"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									Pay Tax with
									<span
										className="caret"
										style={{ marginLeft: "8px" }}
									></span>
								</button>
								<ul
									className="dropdown-menu"
									aria-labelledby="about-us"
								>
									{/* <li>
										<NavLink to="/unifiedpayment">
											<span
												style={{ marginRight: "5px" }}
											>
												<img
													src={UnifiedPaymentsLogo}
													alt="Unified Payments"
													style={{ height: "23px" }}
												/>
											</span>
											<span>Unified Payment</span>
										</NavLink>
									</li> */}
									<li>
										<NavLink to="/flutterwavepage">
											<span
												style={{ marginRight: "5px" }}
											>
												<img
													src={FlutterwaveLogo}
													alt="Flutterwave"
													style={{ height: "23px" }}
												/>
											</span>
											<span>Flutterwave</span>
										</NavLink>
									</li>
									<li>
										<NavLink to="/remitapage">
											<span
												style={{ marginRight: "5px" }}
											>
												<img
													src={RemitaLogo}
													alt="Remita Payments"
													style={{ height: "22px" }}
												/>
											</span>
											<span>Remita pay</span>
										</NavLink>
									</li>
									{/* <li>
										<NavLink to="/interswitchpage">
											<span
												style={{ marginRight: "5px" }}
											>
												<img
													src={InterswitchLogo}
													alt="Interswitch"
													style={{ height: "23px" }}
												/>
											</span>
											<span>Interswitch</span>
										</NavLink>
									</li> */}
									<li>
										<NavLink to="/etransacpage">
											<span
												style={{ marginRight: "5px" }}
											>
												<img
													src={EtransacLogo}
													alt="E-transac"
													style={{ height: "23px" }}
												/>
											</span>
											<span>E-transac</span>
										</NavLink>
									</li>
								</ul>
							</div>

							<footer>
								<div className={styles.socials}>
									<Instagram />
									<Facebook />
									<X />
								</div>

								<div className={styles.footer__info}>
									<small>
										&copy; Copyright{" "}
										{new Date().getFullYear()} ESIRS. All
										rights reserved
									</small>
									<small>
										Powered by <Norlics />
									</small>
								</div>
							</footer>
						</div>
					)}
				</header>

				<section>
					<div className={styles.preHero}>
						<div className={styles.newsBg}>News</div>
						<div className={styles.text}>
							<span>
								Enugu State Govt to construct modern transport
								terminal (Source: AIT)
							</span>
							<span>
								Enugu partners firm to revitalise palm produce
								company (Source: Nigerian Guardian)
							</span>
							<span>
								{" "}
								Enugu: Mbah gives full scholarship to 17-year
								old aspiring pilot (Source: Champion Newspapers
								Limited){" "}
							</span>
							<span>
								Enugu Modern Transport Interchange: Payment of
								compensation to Holy Ghost property owners
								begins (Source: Daily Post)
							</span>
						</div>
						<div className={styles.text}>
							<span>
								Enugu State Govt to construct modern transport
								terminal (Source: AIT)
							</span>
							<span>
								Enugu partners firm to revitalise palm produce
								company (Source: Nigerian Guardian)
							</span>
							<span>
								{" "}
								Enugu: Mbah gives full scholarship to 17-year
								old aspiring pilot (Source: Champion Newspapers
								Limited){" "}
							</span>
							<span>
								Enugu Modern Transport Interchange: Payment of
								compensation to Holy Ghost property owners
								begins (Source: Daily Post)
							</span>
						</div>
					</div>
				</section>
				<main>
					{newsModalShowing && (
						<NewsModal
							toggleModal={setNewsModalShowing}
							modalShowing={newsModalShowing}
						/>
					)}

					<div className={styles.banner}>
						<BannerLogo className={styles.banner__image} />
						<div className={styles.banner__info}>
							<div className={styles.banner__desc}>
								<h1 className="text-success">
									<strong>Enugu State</strong>
								</h1>
								<h1 className={styles.banner__second_title}>
									<strong>
										Central Information Management System{" "}
									</strong>
								</h1>
								<p>
									As Enugu state progresses towards its Mega
									City status, Enugu CMS aims to be a key
									contributor to this growth. Join us in
									paying your taxes and let's thrive together.
								</p>

								<div className={styles.banner__buttons}>
									<div
										className={`dropdown ${styles.dropdown}`}
									>
										<button
											className={`btn btn-default ${styles.nav__payment_btn} dropdown-toggle`}
											type="button"
											id="about-us"
											data-toggle="dropdown"
											aria-haspopup="true"
											aria-expanded="false"
										>
											Pay Tax with
											<span
												className="caret"
												style={{ marginLeft: "8px" }}
											></span>
										</button>
										<ul
											className="dropdown-menu"
											aria-labelledby="about-us"
										>
											{/* <li>
												<NavLink to="/unifiedpaymentpage">
													<span
														style={{
															marginRight: "5px"
														}}
													>
														<img
															src={
																UnifiedPaymentsLogo
															}
															alt="Unified Payments"
															style={{
																height: "23px"
															}}
														/>
													</span>
													<span>Unified Payment</span>
												</NavLink>
											</li> */}
											<li>
												<NavLink to="/flutterwavepage">
													<span
														style={{
															marginRight: "5px"
														}}
													>
														<img
															src={
																FlutterwaveLogo
															}
															alt="Flutterwave"
															style={{
																height: "23px"
															}}
														/>
													</span>
													<span>Flutterwave</span>
												</NavLink>
											</li>
											<li>
												<NavLink to="/remitapage">
													<span
														style={{
															marginRight: "5px"
														}}
													>
														<img
															src={RemitaLogo}
															alt="Remita Payments"
															style={{
																height: "22px"
															}}
														/>
													</span>
													<span>Remita pay</span>
												</NavLink>
											</li>
											{/* <li>
												<NavLink to="/interswitchpage">
													<span
														style={{
															marginRight: "5px"
														}}
													>
														<img
															src={
																InterswitchLogo
															}
															alt="Interswitch"
															style={{
																height: "23px"
															}}
														/>
													</span>
													<span>Interswitch</span>
												</NavLink>
											</li> */}
											<li>
												<NavLink to="/etransacpage">
													<span
														style={{
															marginRight: "5px"
														}}
													>
														<img
															src={EtransacLogo}
															alt="E-transac"
															style={{
																height: "23px"
															}}
														/>
													</span>
													<span>E-transac</span>
												</NavLink>
											</li>
										</ul>
									</div>

									<button
										className={`btn btn-success px-4`}
										type="button"
										onClick={() => history.push("/signup")}
									>
										Register ESBN
									</button>
								</div>
							</div>

							<div className={styles.banner__carousel}>
								<HomeSlider />
							</div>
						</div>
					</div>
					<div className={styles.subscription}>
						<h2 className="text-success">
							<strong>Subscribe to our Newsletter</strong>
						</h2>
						<p>
							Keep updated on the latest events, tax discounts,
							and news in Enugu by subscribing to our newsletter.
						</p>

						<div className={styles.subscription__field}>
							<div className="input-group">
								<input
									type="text"
									className="form-control"
									placeholder="Search for..."
								/>
								<span className="input-group-btn">
									<button
										className="btn btn-success"
										type="button"
									>
										Subscribe <ArrowRight />
									</button>
								</span>
							</div>
						</div>
					</div>
				</main>
				<Footer />
			</div>
		</>
	);
};

export default Home;
